import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const links = [
  { href: '#leistungen', label: 'Leistungen' },
  { href: '#methode', label: 'Methode' },
  { href: '#anwendungen', label: 'Anwendungen' },
  { href: '#roi', label: 'ROI-Rechner' },
  { href: '#esg', label: 'ESG-Reporting' },
  { href: '#angebot', label: 'Angebot' },
  { href: '#kontakt', label: 'Kontakt' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="logo" aria-label="MIBAX Messtechnik – zur Startseite">
          <img
            src="/brand/mibax_logo_v2_transparent.png"
            alt="MIBAX Messtechnik – Logo: Wortmarke MIBAX mit kreisförmigem Schallwellen-Symbol"
            className="h-12 md:h-14 w-auto select-none"
            width="280"
            height="112"
            draggable="false"
            fetchPriority="high"
            decoding="async"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-700 hover:text-[#0891b2] transition-colors font-medium"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#kontakt" className="hidden md:inline-flex btn-primary text-sm" data-testid="header-cta">
          Audit anfragen
        </a>

        <button
          className="md:hidden text-slate-900 p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white/95">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-slate-700 py-2">
                {l.label}
              </a>
            ))}
            <a href="#kontakt" onClick={() => setOpen(false)} className="btn-primary justify-center mt-2" data-testid="mobile-nav-cta">
              Audit anfragen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
